import React, { useState } from "react";
import BusinessModal from "./components/BusinessForm";
import SuccessModal from "./components/SuccessModal";
import { Row, Col } from "antd";
import { useMediaQuery } from "react-responsive";
import YoutubeVideoPlayer from "../../components/assets/YoutubeVideoPlayer";

const MainHeader = () => {
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" });

  return (
    <>
      <div className="header-background-orange"></div>

      <div
        className="margin-100-zero"
        style={{ textAlign: "center", marginBottom: isMobileScreen ? 25 : 180 }}
      >
        <Row gutter={[32, 32]}>
          <Col span={24} lg={{ span: 12 }} className="mt-5">
            <h2>Verslo klientai gauna iki 30% geresnes kainas</h2>
            <YoutubeVideoPlayer borderRadius={20} />
          </Col>
          <Col
            span={24}
            lg={{ span: 12 }}
            style={{
              textAlign: "start",
            }}
          >
            <BusinessModal
              setIsSuccessModalVisible={setIsSuccessModalVisible}
            />
          </Col>
        </Row>
      </div>

      {isSuccessModalVisible && (
        <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
      )}
    </>
  );
};

export default MainHeader;
